// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const SEO_TITLE_FORUM_TOPIC_INFO_category = "O f\u00f3ru %(category)s";
export const SEO_TITLE_FORUM_TOPICS = "V\u0161echno, co maminky zaj\u00edm\u00e1";
